// Tracking configuration for quotation form
export const TRACKING_CONFIG = {
  // Event names
  EVENTS: {
    PAGE_VIEWED: 'quotation_bot_page_viewed',
    STEP_VIEWED: 'quotation_bot_step_viewed',
    STEP_COMPLETED: 'quotation_bot_step_completed',
    FORM_SUBMITTED: 'quotation_bot_form_submitted'
  },

  // Step names
  STEPS: {
    MOTIVE: 'motive-step',
    INSTRUCTIONS: 'instructions-step',
    MODALITY: 'modality-step',
    INTERVIEW_SERVICE: 'interview-service-step',
    PROTAGONIST_INFO: 'protagonist-info-step',
    ADDITIONAL_INFO: 'additional-info-step',
    CONTACT: 'contact-step',
    INCLUDED_SERVICES: 'included-services',
    PRICE_SUMMARY: 'price-summary'
  },

  // Step information mapping
  STEP_INFO: {
    'motive-step': {
      number: 1,
      title: 'Motivo',
      description: 'Selección del motivo de la entrevista'
    },
    'instructions-step': {
      number: 1.5,
      title: 'Instrucciones',
      description: 'Instrucciones para el usuario'
    },
    'modality-step': {
      number: 2,
      title: 'Modalidad',
      description: 'Selección de la modalidad de entrevista'
    },
    'interview-service-step': {
      number: 3,
      title: 'Servicio de Entrevista',
      description: 'Selección del tipo de servicio'
    },
    'protagonist-info-step': {
      number: 4,
      title: 'Información del Protagonista',
      description: 'Datos del protagonista de la entrevista'
    },
    'additional-info-step': {
      number: 5,
      title: 'Información Adicional',
      description: 'Información adicional del proyecto'
    },
    'contact-step': {
      number: 6,
      title: 'Información de Contacto',
      description: 'Datos de contacto del cliente'
    },
    'included-services': {
      number: 7,
      title: 'Servicios Incluidos',
      description: 'Resumen de servicios incluidos'
    },
    'price-summary': {
      number: 8,
      title: 'Resumen de Precio',
      description: 'Resumen del precio total'
    }
  },

  // Sensitive fields to exclude from tracking
  SENSITIVE_FIELDS: [
    'contactFirstName',
    'contactLastName',
    'contactCellphone',
    'contactEmail',
    'protagonistFirstName',
    'protagonistLastName',
    'protagonistNickname'
  ],

  // PostHog configuration
  POSTHOG_CONFIG: {
    apiKey: "phc_7ypifSzd3YrOra4u5xfAa0D4Lk1qqgM6JZIFOpkjiqy",
    apiHost: "https://us.i.posthog.com",
    defaults: "2025-05-24"
  }
};

// Helper functions
export const getStepInfo = (stepName) => {
  return TRACKING_CONFIG.STEP_INFO[stepName] || {
    number: 0,
    title: stepName,
    description: 'Unknown step'
  };
};